import React from 'react';

const orbStyle = (overrides) => ({
  position: 'absolute',
  borderRadius: '50%',
  pointerEvents: 'none',
  animation: 'aurora-drift 20s ease-in-out infinite',
  ...overrides,
});

const orbColor = (cssVar, alpha) => `rgb(var(${cssVar}) / ${alpha})`;

const AuroraBackground = ({ intensity = 1 }) => {
  const a = (base) => (base * intensity).toFixed(3);

  return (
    <>
      <style>{`
        @keyframes aurora-drift {
          0%,  100% { transform: translate(0, 0)         scale(1);    }
          33%        { transform: translate(40px, -30px)  scale(1.07); }
          66%        { transform: translate(-25px, 20px)  scale(0.95); }
        }
      `}</style>
      <div className="aurora-bg" style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0, overflow: 'hidden', transition: 'opacity 0.4s, filter 0.4s' }}>

      {/* Orb 1 — Indigo — vlevo nahoře */}
      <div style={orbStyle({
        width: 700, height: 700,
        top: '-15%', left: '-10%',
        background: `radial-gradient(circle,
          ${orbColor('--orb-1-rgb', a(0.18))}  0%,
          ${orbColor('--orb-1-rgb', a(0.16))}  8%,
          ${orbColor('--orb-1-rgb', a(0.13))} 16%,
          ${orbColor('--orb-1-rgb', a(0.10))} 25%,
          ${orbColor('--orb-1-rgb', a(0.07))} 34%,
          ${orbColor('--orb-1-rgb', a(0.05))} 43%,
          ${orbColor('--orb-1-rgb', a(0.03))} 52%,
          ${orbColor('--orb-1-rgb', a(0.02))} 61%,
          ${orbColor('--orb-1-rgb', a(0.01))} 70%,
          ${orbColor('--orb-1-rgb', a(0.00))} 80%,
          transparent 90%)`,
        animationDuration: '20s',
        filter: 'blur(80px)',
      })} />

      {/* Orb 2 — Violet — vpravo uprostřed */}
      <div style={orbStyle({
        width: 600, height: 600,
        top: '30%', right: '-12%',
        background: `radial-gradient(circle,
          ${orbColor('--orb-2-rgb', a(0.14))}  0%,
          ${orbColor('--orb-2-rgb', a(0.12))}  9%,
          ${orbColor('--orb-2-rgb', a(0.10))} 18%,
          ${orbColor('--orb-2-rgb', a(0.07))} 28%,
          ${orbColor('--orb-2-rgb', a(0.05))} 38%,
          ${orbColor('--orb-2-rgb', a(0.03))} 48%,
          ${orbColor('--orb-2-rgb', a(0.02))} 58%,
          ${orbColor('--orb-2-rgb', a(0.01))} 68%,
          ${orbColor('--orb-2-rgb', a(0.00))} 78%,
          transparent 88%)`,
        animationDuration: '24s',
        animationDelay: '-6s',
        filter: 'blur(80px)',
      })} />

      {/* Orb 3 — Cyan — vlevo dole */}
      <div style={orbStyle({
        width: 500, height: 500,
        bottom: '-10%', left: '20%',
        background: `radial-gradient(circle,
          ${orbColor('--orb-3-rgb', a(0.10))}  0%,
          ${orbColor('--orb-3-rgb', a(0.08))}  9%,
          ${orbColor('--orb-3-rgb', a(0.06))} 19%,
          ${orbColor('--orb-3-rgb', a(0.04))} 30%,
          ${orbColor('--orb-3-rgb', a(0.03))} 41%,
          ${orbColor('--orb-3-rgb', a(0.02))} 52%,
          ${orbColor('--orb-3-rgb', a(0.01))} 63%,
          ${orbColor('--orb-3-rgb', a(0.00))} 75%,
          transparent 87%)`,
        animationDuration: '28s',
        animationDelay: '-13s',
        filter: 'blur(70px)',
      })} />

      </div>
    </>
  );
};

export default AuroraBackground;
